import React from 'react';

interface TextInputProps {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  helperText?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

export const TextInput: React.FC<TextInputProps> = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  placeholder,
  required,
  disabled,
  className = '',
}) => {
  return (
    <div className={className}>
      <label htmlFor={name} className="block text-sm font-semibold text-slate-700 mb-2">
        {label}
        {required && <span className="text-rose-500 ml-1">*</span>}
      </label>
      <input
        id={name}
        name={name}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        className={`
          w-full px-4 py-3 text-sm border-2 rounded-xl transition-all duration-200
          ${disabled
            ? 'bg-slate-50 text-slate-400 cursor-not-allowed border-slate-200'
            : 'bg-white hover:border-slate-300'}
          ${error
            ? 'border-rose-300 focus:border-rose-500 focus:ring-4 focus:ring-rose-100'
            : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100'}
          focus:outline-none placeholder:text-slate-400
        `}
      />
      {error && (
        <p className="text-rose-600 text-xs mt-2 flex items-center gap-1">
          <span className="w-1 h-1 rounded-full bg-rose-500" />
          {error}
        </p>
      )}
      {helperText && !error && (
        <p className="text-slate-500 text-xs mt-2">{helperText}</p>
      )}
    </div>
  );
};
